import { UserProfile } from './user-profile';
import { UserProfileProvider } from './user-profile.provider';

export const FeatureUserProfile = () => {
   return (
      <UserProfileProvider>
         <UserProfile></UserProfile>
      </UserProfileProvider>
   );
};
